// Environment detection utility

export const getEnvironment = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 
                    process.env.STAGING_API_BASE_URL || 
                    'http://localhost:3030';
  
  const hostname = window.location.hostname;
  
  // Determine environment based on hostname and API URL
  if (hostname === 'admin.kasam.app') {
    return { name: 'PRODUCTION', color: 'bg-red-500' };
  } else if (hostname === 'dev-admin.kasam.app') {
    return { name: 'DEVELOPMENT', color: 'bg-yellow-500' };
  } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return { name: 'LOCAL', color: 'bg-blue-500' };
  } else {
    return { name: 'UNKNOWN', color: 'bg-gray-500' };
  }
};

export const isProduction = () => {
  return getEnvironment().name === 'PRODUCTION';
};

export const isDevelopment = () => {
  return getEnvironment().name === 'DEVELOPMENT';
};

export const isLocal = () => {
  return getEnvironment().name === 'LOCAL';
};